import { useQuery } from '@tanstack/react-query';
import * as Effect from 'effect/Effect';
import { pipe } from 'effect/Function';
import { ApiClient } from '@/api/client';
import { MainLayer } from '@/effects/layers';
import { runEffect } from '@/effects/runtime';
import { UsersResponseSchema } from '@/api/schemas/user.schema';

export function useAllUsers() {
  return useQuery({
    queryKey: ['all-users'],
    queryFn: async () => {
      const program = pipe(
        ApiClient,
        Effect.flatMap((api) => api.get('/users', UsersResponseSchema)),
        Effect.map((response) => response.users),
        Effect.provide(MainLayer)
      );

      return runEffect(program);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}